import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { Button } from '../../ui/button';
import { cn } from '../../../lib/utils';
import { UserPlus, Mail, Phone, BookOpen, Edit, X } from 'lucide-react';

export const CounselorsContent = ({
  counselors,
  setEditingCounselor,
  setNewCounselor,
  setShowCounselorModal,
  openEditCounselor,
  handleDeleteCounselor
}) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Eğitim Danışmanları</h2>
          <p className="text-gray-500">Danışman yönetimi ve atama işlemleri</p>
        </div>
        <Button 
          className="bg-purple-600 hover:bg-purple-700"
          onClick={() => {
            setEditingCounselor(null);
            setNewCounselor({ name: '', email: '', phone: '', title: '', specialization: '', is_active: true });
            setShowCounselorModal(true);
          }}
        >
          <UserPlus className="w-4 h-4 mr-2" />
          Yeni Danışman
        </Button>
      </div>

      {/* Danışman Kartları */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {counselors.map(counselor => (
          <Card key={counselor.id} className="border-0 shadow-lg">
            <CardContent className="p-5">
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                    {counselor.name?.charAt(0)}
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800">{counselor.name}</h3>
                    <p className="text-sm text-purple-600">{counselor.title || 'Eğitim Danışmanı'}</p>
                  </div>
                </div>
                <div className={cn(
                  "px-2 py-0.5 rounded-full text-xs font-medium",
                  counselor.is_active !== false ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"
                )}>
                  {counselor.is_active !== false ? 'Aktif' : 'Pasif'}
                </div>
              </div>
              
              <div className="space-y-2 text-sm">
                {counselor.email && (
                  <div className="flex items-center gap-2 text-gray-600">
                    <Mail className="w-4 h-4" />
                    {counselor.email}
                  </div>
                )}
                {counselor.phone && (
                  <div className="flex items-center gap-2 text-gray-600">
                    <Phone className="w-4 h-4" />
                    {counselor.phone}
                  </div>
                )}
                {counselor.specialization && (
                  <div className="flex items-center gap-2 text-gray-600">
                    <BookOpen className="w-4 h-4" />
                    {counselor.specialization}
                  </div>
                )}
              </div>
              
              <div className="mt-4 pt-4 border-t flex items-center justify-between">
                <div className="text-sm">
                  <span className="font-bold text-purple-600 text-lg">{counselor.student_count || 0}</span>
                  <span className="text-gray-500 ml-1">Öğrenci</span>
                </div>
                <div className="flex gap-1">
                  <Button variant="ghost" size="sm" onClick={() => openEditCounselor(counselor)}>
                    <Edit className="w-4 h-4" />
                  </Button>
                  <Button 
                    variant="ghost" 
                    size="sm" 
                    className="text-red-500 hover:text-red-700"
                    onClick={() => handleDeleteCounselor(counselor.id)}
                  >
                    <X className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        
        {counselors.length === 0 && (
          <div className="col-span-full text-center py-12 text-gray-400">
            <UserPlus className="w-12 h-12 mx-auto mb-4 opacity-50" />
            <p>Henüz danışman eklenmemiş</p>
            <p className="text-sm">Yeni danışman eklemek için butona tıklayın</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CounselorsContent;
